import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchRateArticleThunk, rateArticleThunk } from "./userArticle.actions";
import { showToast } from "utils/helpers/toastHelper";

export const rateArticle = createAsyncThunk(
  "userArticle/rateArticle",
  rateArticleThunk
);

export const fetchFavoriteAndRateArticle = createAsyncThunk(
  "userArticle/fetchFavoriteAndRateArticle",
  fetchRateArticleThunk
);

const favorite_articles = {
  is_fetch: false,
  list: [],
  meta: {},
};
const rate_articles = {
  is_fetch: false,
  list: [],
  meta: {},
};
const initialState = {
  favorite_articles: favorite_articles,
  rate_articles: rate_articles,
};

const UserArticleSlice = createSlice({
  name: "userArticle",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(rateArticle.fulfilled, (state, { payload }) => {
        showToast(payload, "success");
      })
      .addCase(fetchFavoriteAndRateArticle.fulfilled, (state, { payload }) => {
        if (payload.type === "rated") {
          return {
            ...state,
            rate_articles: {
              is_fetch: true,
              list: payload.data,
              meta: payload.meta,
            },
          };
        } else if (payload.type === "favorite") {
          return {
            ...state,
            favorite_articles: {
              is_fetch: true,
              list: payload.data,
              meta: payload.meta,
            },
          };
        }
      })
      .addCase(fetchFavoriteAndRateArticle.pending, (state, action) => {
        const { meta } = action; // meta sadrži informacije o pozivu
        if (meta.arg.type === "rated") {
          return {
            ...state,
            rate_articles: {
              is_fetch: false,
              list: [],
              meta: {},
            },
          };
        } else if (meta.arg.type === "favorite") {
          return {
            ...state,
            favorite_articles: {
              is_fetch: false,
              list: [],
              meta: {},
            },
          };
        }
      })
      .addCase(fetchFavoriteAndRateArticle.rejected, (state, action) => {
        const { meta } = action;

        if (meta.arg.type === "rated") {
          return {
            ...state,
            rate_articles: {
              is_fetch: true,
              list: [],
              meta: {},
            },
          };
        } else if (meta.arg.type === "favorite") {
          return {
            ...state,
            favorite_articles: {
              is_fetch: true,
              list: [],
              meta: {},
            },
          };
        }
      });
  },
});

export default UserArticleSlice.reducer;
